import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideTransloco } from '@jsverse/transloco';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routes } from './app.routes';
import { refreshTokenInterceptor } from './auth/interceptors/refresh-token-interceptor';
import { tokenInterceptor } from './auth/interceptors/token-interceptor';
import { TranslocoHttpLoader } from './transloco-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(MatSnackBarModule),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([tokenInterceptor, refreshTokenInterceptor]),
    ),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: isDevMode(),
    }),

    provideTransloco({
      config: {
        availableLangs: ['en', 'bg'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
